import styles from './style.module.css';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { Clipboard } from '../../components/Clipboard';
import { CountdownAction } from '../../components/CountdownAction';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';
import { Loading } from '../../components/Loading';
import { ModalPosterPrint } from '../../components/ModalPosterPrint';
import { ShareButton } from '../../components/ShareButtons';
import { Slide, SlideItem } from '../../components/Slide';
import { TextReveal } from '../../components/TextReveal';
import { useAuth } from '../../hooks/useAuth';
import { api, getAPIURL } from '../../server/api';
import { getYouTubeEmbed } from '../../utils/getYouTubeEmbed';
import { IDataSlide } from '../Home/interfaces';
import * as routes from './../../constants/Routes';
import QRCode from 'qrcode.react';
import { QrcodeWithPdf } from '../../components/QrcodeWithPdf';
import { Input } from '../../components/forms/Input';
import { Notify } from '../../components/Notify';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ModalContact } from '../Action/components/ModalContact';
import { getSearchParams } from '../../utils/getSearchParams';
import { IPlayerPerformance } from '../../interfaces/IPlayerPerformance';
import { IAction } from '../../interfaces/IAction';
import { IPorteiro } from '../../interfaces/IFormPorteiro';
import YouTube from 'react-youtube';

interface IFormValuesVivaz {
  email: string;
  phone: string;
  name: string;
}
const youtubeRegex = /^https?:\/\/(www\.)?youtube\.com\/watch\?v=[\w-]+/;

export function ActionDetails() {
  const { client, playerAuth, player } = useAuth();
  const { actionId } = useParams();
  const navigate = useNavigate();

  const { register, handleSubmit, setValue } = useForm<IPorteiro>();

  const vivazForm = useForm<IFormValuesVivaz>();

  const [action, setAction] = useState<IAction>({} as IAction);
  const [shareUrl, setShareUrl] = useState<string>();
  const [imagesAction, setImagesAction] = useState<any>();
  const [actionImagesBase64, setActionImagesBase64] = useState<any>();
  const [validationCode, setValidationCode] = useState<string>('');
  const [isLoadingActionDetails, setIsLoadingActionDetails] =
    useState<boolean>(true);
  const [dataSlide, setDataSlide] = useState<Array<IDataSlide>>([]);
  const [countdownString, setCountdownString] = useState<string>();
  const [cartazCover, setCartazCover] = useState<any>();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [individualMeta, setIndividualMeta] = useState<number>();
  const [playerRegister, setPlayerRegister] = useState<any>();
  const [totalMeta, setTotalMeta] = useState(0);
  const [acumulativeMeta, setAcumulativeMeta] = useState(0);
  const [contactModalIsOpen, setContactModalIsOpen] = useState<boolean>(false);
  const [isParamAutoIndcate, setIsParamAutoIndcate] = useState<boolean>(false);
  const [playerPerformance, setPlayerPerformance] =
    useState<IPlayerPerformance>();
  const toggleModalIsOpen = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const imageUrlToBase64 = async (url: any): Promise<any> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((onSuccess, onError) => {
      try {
        const reader = new FileReader();
        reader.onload = function () {
          onSuccess(this.result);
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        onError(e);
      }
    });
  };

  const updateCountdown = (action: any) => {
    if (!action) return '00:00';

    const now = moment();
    const dateInFuture = moment(action.endDateEpoch);

    const ms = moment(dateInFuture).diff(moment(now));
    const d = moment.duration(ms);

    const countdownString = `${Math.floor(d.asDays())}d${moment
      .utc(ms)
      .format('HH[h]mm[m]')}`;

    setCountdownString(countdownString);
  };

  const errosPorteiro = (data) => {
    if (data.patrimonNumber) {
      toast.warning(data.patrimonNumber.message);
    }
    if (data.patrimonPrice) {
      toast.warning(data.patrimonPrice.message);
    }
    if (data.patrimonPriceCondominium) {
      toast.warning(data.patrimonPriceCondominium.message);
    }
    if (data.patrimonTypeAction) {
      toast.warning(data.patrimonTypeAction.message);
    }
  };

  const errosVivaz = (data) => {
    if (data.name) {
      toast.warning(data.name.message);
    }
    if (data.email) {
      toast.warning(data.email.message);
    }
    if (data.patrimonPriceCondominium) {
      toast.warning(data.patrimonPriceCondominium.message);
    }
    if (data.phone) {
      toast.warning(data.phone.message);
    }
  };

  const adicionarPrefixoAleatorio = (email: string) => {
    // Verifica se o e-mail é válido
    if (!email.includes('@')) {
      throw new Error('Email inválido');
    }

    // Divide o e-mail em parte local e domínio
    const partes = email.split('@');
    const parteLocal = partes[0];
    const dominio = partes[1];

    // Gera o prefixo aleatório e cria o novo e-mail
    const prefixoAleatorio = gerarPrefixoAleatorio();
    const novoEmail = `${parteLocal}+${prefixoAleatorio}@${dominio}`;

    return novoEmail;
  };

  const maskTel = (value: string): string => {
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
    value = value.replace(/(\d)(\d{4})$/, '$1-$2');
    return value;
  };

  const maskDecimal = (v: string): string => {
    if (!v) return '';
    v = v.replace(/\D/g, '');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return v;
  };

  const getActionById = useCallback(
    async (actionId: string) => {
      try {
        const hostname = getAPIURL();

        const parameters = {
          searchFunctionality: 'getAction',
          userType: 'player',
          actionId,
          clientId: client.id,
          hostname,
        };

        const { data } = await api.post(`/search`, parameters);

        if (data.success) {
          setAction(data.data.action);
          setShareUrl(data.data.action.shareUrl);
          setImagesAction(data.data.action.images);
          if (
            data.data &&
            data.data.action &&
            data.data.action.actionType !== 'quiz'
          ) {
            registerPlayerOnAction();
          }
        }
      } catch (error) {
        console.log('error getActionById', error);
      } finally {
        setIsLoadingActionDetails(false);
      }
    },
    [client]
  );

  const registerPlayerOnAction = useCallback(async () => {
    try {
      const parameters = {
        searchFunctionality: 'registerPlayerInAction',
        userType: 'player',
        actionId,
        clientId: client.id,
      };

      await api.post(`/actions`, parameters);

      await getValidationCode(actionId ? actionId : '');
    } catch (error) {
      console.log('error registerPlayerOnAction', error);
    }
  }, [actionId, client]);

  const getValidationCode = useCallback(
    async (actionId: string) => {
      try {
        const parameters = {
          actionId,
          playerId: player.id,
          clientId: client.id,
          userType: 'client',
          searchFunctionality: 'validationCode',
        };

        const { data } = await api.post(`/search`, parameters);

        if (data.success) setValidationCode(data.data[0].validationCode);
      } catch (error) {
        console.log('error getValidationCode-->', error);
      }
    },
    [player, client]
  );

  const getSelfPlayerRegisterDetails = useCallback(async () => {
    try {
      const parameters = {
        searchFunctionality: 'getSelfPlayerRegisterDetails',
        userType: 'player',
        playerId: playerAuth.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);
      setPlayerRegister(data.data.player);
      setIndividualMeta(data.data.player.individualMeta);
    } catch (error) {
      console.log('getSelfPlayerRegisterDetails error:', error);
    }
  }, [playerAuth, client]);

  const updatePlayerIndividualMeta = useCallback(async () => {
    const parameters = {
      playerData: {
        targetPublic: client && client.targetPublic,
        ...playerRegister,
        individualMeta,
        acumulativeMeta,
        totalMeta,
        editing: true,
      },
      userType: 'player',
      updateFunctionality: 'updatePlayer',
    };

    const response = await api.post(`/update`, parameters);

    if (response.data.success) {
      Notify('Meta individual definida!', 'success');
    }
  }, [acumulativeMeta, client, individualMeta, playerRegister, totalMeta]);

  const saveLeadPorteiro = useCallback(
    async (data: IPorteiro) => {
      const player = playerRegister;

      const fullName = player.name;

      const token =
        Math.random().toString(36).substr(2, 9) +
        Math.random().toString(36).substring(2, 9);

      const geoReference = await getGeolocation(player.patrimonyCep);

      const parameters = {
        createFunctionality: 'registerLead',
        userType: 'consumer',
        lead: {
          ...data,
          geoReference: geoReference ? geoReference : {},
          name: fullName,
          patrimonType: 'Apartamento',
          patrimonCep: player.patrimonyCep,
          email: adicionarPrefixoAleatorio(player.email),
          actionId: actionId,
          playerId: player.id,
          clientId: client.id,
          converted: false,
          leadToken: token,
          acceptedTerms: true,
        },
        clientId: client.id,
        playerId: player.id,
        validationCode: validationCode,
        urlOrigem: window.location.href,
      };

      await api
        .post('/create', parameters)
        .then(async (res) => {
          const result = res.data;

          if (result.success) {
            setContactModalIsOpen(!contactModalIsOpen);
          }
        })
        .catch((error) => console.log('Error create lead', error));
    },
    [actionId, client, contactModalIsOpen, playerRegister, validationCode]
  );

  const saveLeadVivaz = useCallback(
    async (data: IFormValuesVivaz) => {
      const player = playerRegister;

      const token =
        Math.random().toString(36).substr(2, 9) +
        Math.random().toString(36).substring(2, 9);

      const parameters = {
        createFunctionality: 'registerLead',
        userType: 'consumer',
        lead: {
          ...data,
          email: data.email,
          actionId: actionId,
          playerId: player.id,
          clientId: client.id,
          converted: false,
          leadToken: token,
          acceptedTerms: true,
        },
        clientId: client.id,
        playerId: player.id,
        validationCode: validationCode,
        urlOrigem: window.location.href,
      };

      await api
        .post('/create', parameters)
        .then(async (res) => {
          const result = res.data;

          if (result.success) {
            toast.info(result.message);
          } else {
            toast.info(result.message);
            console.log('não deu certo', result);
          }
        })
        .catch((error) => console.log('Error create lead', error));
    },
    [actionId, client, contactModalIsOpen, playerRegister, validationCode]
  );

  const getPlayerPerformance = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/actions/quiz/player-performances/${actionId}/${player.id}`
      );

      setPlayerPerformance(data.body);
    } catch (error) {
      console.log('getPlayerPerformance error: ', error);
    }
  }, [actionId, player]);

  const getGeolocation = useCallback(async (cep) => {
    const uri = `https://cep.awesomeapi.com.br/json/${cep}`;
    try {
      const result = await axios.get(uri);
      return result.data;
    } catch (error) {
      return false;
    }
  }, []);

  const openContactModal = () => {
    setContactModalIsOpen(!contactModalIsOpen);
  };

  const gerarPrefixoAleatorio = () => {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let prefixo = '';
    for (let i = 0; i < 5; i++) {
      const randomIndex = Math.floor(Math.random() * caracteres.length);
      prefixo += caracteres[randomIndex];
    }
    return prefixo;
  };

  useEffect(() => {
    if (actionId) {
      getActionById(actionId);
    }
    if (client && playerAuth) {
      getSelfPlayerRegisterDetails();
    }

    if (getSearchParams('auto')) {
      setIsParamAutoIndcate(true);
    }
  }, [
    actionId,
    client,
    getActionById,
    getSelfPlayerRegisterDetails,
    playerAuth,
  ]);

  useEffect(() => {
    if (player) {
      getPlayerPerformance();
    }
    if (player && player.acumulativeMeta && player.acumulativeMeta > 0) {
      setAcumulativeMeta(player.acumulativeMeta);
    }

    if (player && player.totalMeta && player.totalMeta > 0) {
      setTotalMeta(player.totalMeta);
    }
  }, [player]);

  useEffect(() => {
    const dataCompareAction = async () => {
      if (action && action.images) {
        let imageUrl = '';
        let imgBase64 = '';
        const logoImgBase64 = await imageUrlToBase64(client.logoURL);
        const qrCodeBase64 = await imageUrlToBase64(
          `https://api.qrserver.com/v1/create-qr-code/?data=${action.shareUrl}`
        );

        if (
          action.defaultImagePoster &&
          action.defaultImagePoster !== 'false'
        ) {
          imageUrl = action.defaultImagePoster;
          imgBase64 = await imageUrlToBase64(imageUrl);
        } else {
          imageUrl = action.images[0]?.url;
          imgBase64 = await imageUrlToBase64(action.images[0]?.url);
        }
        setDataSlide([
          { urlImages: action.images },
          {
            urlVideo: action.videoURL ? getYouTubeEmbed(action.videoURL) : '',
          },
        ]);

        setCartazCover({
          imageUrl,
          imgBase64,
          logoImgBase64,
          qrCodeBase64,
        });
      }

      updateCountdown(action);
    };

    dataCompareAction();
  }, [action]);

  useEffect(() => {
    if (imagesAction) {
      const responseBase64 = imagesAction.map(async (image: any) => {
        const imageUrl = image.url;
        const imgBase64 = await imageUrlToBase64(image.url);

        return {
          actionId: actionId,
          imageUrl,
          imgBase64,
        };
      });

      Promise.all(responseBase64).then((response) =>
        setActionImagesBase64(response)
      );
    }
  }, [imagesAction]);
  if (isLoadingActionDetails) {
    return <Loading />;
  }

  return (
    <>
      <HelmetComponent
        actionImages={action?.images}
        actionTitle={action?.actionTitle}
        clientLogoURL={client?.logoURL}
        clientFavicon={client?.favIcon}
        companyName={client?.companyName}
        playerName={player?.name}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Detalhes da action'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Publicação" />
          </div>
        </div>
        <div className="row">
          <div
            className={
              action.shareButtonsVisible &&
              client &&
              ((action.actionType === 'researchAward' &&
                client.clientUrl === 'md') ||
                action.conversionType === 'autoindicate' ||
                isParamAutoIndcate)
                ? 'col-sm-12 col-lg-12'
                : 'col-sm-12 col-md-12 col-xl-8'
            }
          >
            <Card>
              <Slide>
                <SlideItem key={action.id} active={true} slide={dataSlide} />
              </Slide>

              {action.actionType === 'quiz' ? (
                <>
                  <TextReveal
                    title={action.actionTitle}
                    subtitle={action.callToAction}
                    content={`Leia todas as questões com atenção. Você pode ou não ganhar ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'} se acertar as respostas. Ao final do Quiz, você terá acesso ao porcentual de erros e acertos para saber como foi seu desempenho.`}
                    conversionFieldName="+ detalhes do conteúdo"
                    dataSheet={
                      action.filePDF ? action.filePDF.fileArquiveQuiz : ''
                    }
                  />
                  <List>
                    <ListItem
                      icon="content_paste"
                      content="Link de conteúdo"
                      secondaryContent={
                        <a href={action.videoURL} target="_blank">
                          Acessar conteúdo
                        </a>
                      }
                    />
                  </List>
                  {youtubeRegex.test(action.videoURL) ? (
                    <YouTube
                      videoId={action.videoURL.split('=')[1]}
                      opts={{
                        height: '390',
                        width: '100%',
                        playerVars: {
                          autoplay: 1, // Ativa autoplay
                        },
                      }}
                    />
                  ) : (
                    <iframe
                      src={
                        action.filePDF
                          ? action.filePDF.fileArquiveQuiz
                          : action.videoURL
                      }
                      style={{ width: '100%', height: '390px' }}
                      className="w-full h-full"
                      title="Content preview"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    />
                  )}
                </>
              ) : (
                <>
                  {action && action.description && (
                    <>
                      <TextReveal
                        title={action.actionTitle}
                        content={action.description}
                        subtitle={action.actionSubtitle}
                        conversionFieldName={action?.conversionFieldName}
                        dataSheet={
                          action?.files && action?.files.dataSheet
                            ? action?.files.dataSheet
                            : ''
                        }
                      />
                      {action.conversionType !== 'autoindicate' &&
                        !isParamAutoIndcate && (
                          <TextReveal
                            content={action.rulesOfAction}
                            subtitle="Regras do programa"
                          />
                        )}

                      {(action.conversionType === 'autoindicate' ||
                        isParamAutoIndcate) &&
                        client.clientUrl !== 'bomnegocio' && (
                          <>
                            <form
                              onSubmit={vivazForm.handleSubmit(
                                saveLeadVivaz,
                                errosVivaz
                              )}
                            >
                              <div className="row">
                                <div className="col-sm-12 col-md-6">
                                  <div className="mb-3">
                                    <label htmlFor="name">Nome</label>
                                    <Input
                                      type="text"
                                      placeholder="Nome"
                                      name="numberPatrimonIndication"
                                      {...vivazForm.register('name', {
                                        required: 'Informe Nome',
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                  <div className="mb-3">
                                    <label htmlFor="name">Email</label>
                                    <Input
                                      type="email"
                                      placeholder="Email"
                                      name="numberPatrimonIndication"
                                      {...vivazForm.register('email', {
                                        required: 'Informe Email',
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                  <div className="mb-3">
                                    <label htmlFor="name">WhatsApp</label>
                                    <Input
                                      type="text"
                                      placeholder="WhatsApp"
                                      name="numberPatrimonIndication"
                                      {...vivazForm.register('phone', {
                                        required: 'Informe WhatsApp',
                                      })}
                                      maxLength={15}
                                      onChange={(event) => {
                                        const { value } = event.target;
                                        event.target.value = maskTel(value);
                                        const verifyLengthValue = value.replace(
                                          /\D/g,
                                          ''
                                        );
                                        if (verifyLengthValue.length > 11) {
                                          return Notify(
                                            'Formato de WhatsApp incorreto',
                                            'warn'
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="d-grid">
                                    <Button
                                      text={
                                        client.clientUrl === 'primeclinic' &&
                                        action.conversionType === 'autoindicate'
                                          ? 'Marcar agora'
                                          : 'Enviar indicação'
                                      }
                                      isLoading={
                                        vivazForm.formState.isSubmitting
                                      }
                                      disabled={
                                        vivazForm.formState.isSubmitting
                                      }
                                      color="primary"
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </>
                        )}

                      {action.conversionType === 'autoindicate' &&
                        client.clientUrl === 'bomnegocio' && (
                          <form
                            onSubmit={handleSubmit(
                              saveLeadPorteiro,
                              errosPorteiro
                            )}
                          >
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                  <label htmlFor="name">
                                    Andar/Número do apartamento
                                  </label>
                                  <Input
                                    type="number"
                                    placeholder="Andar/Número do apartamento"
                                    name="numberPatrimonIndication"
                                    autoComplete="off"
                                    {...register('patrimonNumber', {
                                      required:
                                        'Informe Andar/Número do apartamento',
                                    })}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                  <label htmlFor="name">
                                    Valor aproximado de venda/aluguel
                                  </label>
                                  <Input
                                    type="text"
                                    placeholder="Valor aproximado de venda/aluguel"
                                    name="numberPatrimonIndication"
                                    autoComplete="off"
                                    {...register('patrimonPrice', {
                                      required:
                                        'Informe Valor aproximado de venda/aluguel',
                                      onChange: (e) => {
                                        const { value } = e.target;
                                        setValue(
                                          'patrimonPrice',
                                          maskDecimal(value)
                                        );
                                      },
                                    })}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                  <label htmlFor="name">
                                    valor do condomínio
                                  </label>
                                  <Input
                                    type="text"
                                    placeholder="valor do condomínio"
                                    name="numberPatrimonIndication"
                                    autoComplete="off"
                                    {...register('patrimonPriceCondominium', {
                                      required: 'Informe valor do condomínio',
                                      onChange: (e) => {
                                        const { value } = e.target;
                                        setValue(
                                          'patrimonPriceCondominium',
                                          maskDecimal(value)
                                        );
                                      },
                                    })}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6">
                                <label htmlFor="correctors">Imóvel para</label>
                                <select
                                  className={`${styles.select}`}
                                  {...register('patrimonTypeAction', {
                                    required: 'Informe aluguel/venda',
                                  })}
                                >
                                  <option value="" selected disabled>
                                    Selecione
                                  </option>
                                  <option value="Alugar">Alugar</option>
                                  <option value="Vender">Vender</option>
                                </select>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                  <label htmlFor="name">
                                    Telefone do proprietário, caso tenha.
                                  </label>
                                  <Input
                                    type="number"
                                    placeholder="Telefone do proprietário"
                                    name="patrimonOwnerPhone"
                                    autoComplete="off"
                                    {...register('patrimonOwnerPhone')}
                                  />
                                </div>
                              </div>
                              <Button text="Enviar indicação" color="primary" />
                            </div>
                          </form>
                        )}
                    </>
                  )}
                </>
              )}

              {action && action.actionType === 'researchAward' && (
                <>
                  {action &&
                    action.videoURL === '' &&
                    action.files &&
                    action.files.image1 && (
                      <img
                        className="w-100 rounded-3"
                        src={action && action.files.image1}
                        alt=""
                      />
                    )}

                  {action &&
                    action.videoURL === '' &&
                    action.images &&
                    action.images.length > 0 && (
                      <div
                        id="carouselExampleIndicators"
                        className="carousel slide"
                        data-bs-ride="carousel"
                      >
                        <div className="carousel-indicators">
                          {action.images.map((_: any, index: number) => (
                            <button
                              key={index}
                              type="button"
                              data-bs-target="#carouselExampleIndicators"
                              data-bs-slide-to={index}
                              className={index === 0 ? 'active' : ''}
                              aria-current={index === 0 ? 'true' : 'false'}
                              aria-label={`Slide ${index + 1}`}
                            ></button>
                          ))}
                        </div>
                        <div className="carousel-inner">
                          {action.images.map((image: any, index: number) => (
                            <div
                              key={index}
                              className={`carousel-item ${index === 0 ? 'active' : ''}`}
                            >
                              <img
                                src={image}
                                className="d-block w-100 rounded-3"
                                alt={`Slide ${index + 1}`}
                              />
                            </div>
                          ))}
                        </div>
                        {action.images.length > 1 && (
                          <>
                            <button
                              className="carousel-control-prev"
                              type="button"
                              data-bs-target="#carouselExampleIndicators"
                              data-bs-slide="prev"
                            >
                              <span
                                className="carousel-control-prev-icon"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Previous</span>
                            </button>
                            <button
                              className="carousel-control-next"
                              type="button"
                              data-bs-target="#carouselExampleIndicators"
                              data-bs-slide="next"
                            >
                              <span
                                className="carousel-control-next-icon"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Next</span>
                            </button>
                          </>
                        )}
                      </div>
                    )}

                  {action && action.videoURL && action.videoURL !== '' && (
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={getYouTubeEmbed(action.videoURL)}
                        className="rounded-3"
                        allow="accelerometer; autoplay; loop; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}

                  <TextReveal
                    title={action.actionTitle}
                    subtitle={action.callToAction}
                    content=""
                  />

                  {action.questions &&
                    action.questions['0'].choiceQuestion === 'text' && (
                      <>
                        <Input
                          label={`${action.callToAction} - De ${moment(
                            action.startDate
                          ).format('DD/MM/YY')} até ${moment(
                            action.endDate
                          ).format('DD/MM/YY')}`}
                          type="number"
                          placeholder={action.callToAction}
                          name="meta"
                          value={individualMeta}
                          onChange={(e) => {
                            setIndividualMeta(Number(e.target.value));
                          }}
                        />
                        <div className="mt-3">
                          <Button
                            text="Concluir"
                            icon="check"
                            color="flat"
                            onClick={() => {
                              updatePlayerIndividualMeta();
                            }}
                          />
                        </div>
                      </>
                    )}
                </>
              )}
            </Card>
          </div>
          {action && action.actionType === 'quiz' && (
            <div className="col-sm-12 col-md-12 col-xl-4">
              <div className="my-3 my-xl-0">
                <Card>
                  <span className="fw-semibold">Detalhes</span>
                  <hr />
                  {playerPerformance?.nOfAttempts > 0 && (
                    <div className="my-3">
                      <div className="mt-3">
                        <p>Sua pontuação foi:</p>
                        <span
                          className={`badge bg-secondary w-100 center-text fs-5 ${
                            playerPerformance?.pointsInBestAttempt > 0
                              ? 'bg-success'
                              : 'bg-danger'
                          }`}
                        >
                          {`${playerPerformance?.pointsInBestAttempt} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                        </span>
                      </div>
                    </div>
                  )}
                  <List>
                    <ListItem
                      icon="assignment_turned_in"
                      styleIcon="outlined"
                      content={`Vale`}
                      secondaryContent={`${action.quizDetails?.quizRewardPoints} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                    />
                    <ListItem
                      icon="live_help"
                      styleIcon="outlined"
                      content="Tipo de quiz"
                      secondaryContent={
                        action.quizDetails?.quizType === 'performance'
                          ? 'Performance'
                          : 'Pontuação'
                      }
                    />
                    <ListItem
                      icon="format_list_numbered"
                      styleIcon="outlined"
                      content="Número de questões"
                      secondaryContent={action.amountOfQuestions}
                    />

                    {action.quizDetails?.quizType === 'performance' && (
                      <>
                        <ListItem
                          icon="flag"
                          styleIcon="outlined"
                          content="Mínimo de acerto"
                          secondaryContent={`${action.quizDetails?.minimumScore} %`}
                        />
                        <ListItem
                          icon="redo"
                          styleIcon="outlined"
                          content="Tentativas possíveis"
                          secondaryContent={action.quizDetails?.amountOfRetries}
                        />
                        <ListItem
                          icon="history"
                          styleIcon="outlined"
                          content="Total de tentativas"
                          secondaryContent={playerPerformance?.nOfAttempts}
                        />
                        <ListItem
                          icon="update"
                          styleIcon="outlined"
                          content="Tentativas restantes"
                          secondaryContent={
                            action.quizDetails?.amountOfRetries -
                              playerPerformance?.nOfAttempts >
                            0
                              ? action.quizDetails?.amountOfRetries -
                                playerPerformance?.nOfAttempts
                              : 0
                          }
                        />
                      </>
                    )}
                    {action.quizDetails?.quizType !== 'performance' && (
                      <ListItem
                        icon="lock"
                        styleIcon="outlined"
                        content="Resposta única"
                        secondaryContent={
                          action.quizChoice === 'true' ? 'Sim' : 'Não'
                        }
                      />
                    )}
                    <ListItem
                      icon="pending_actions"
                      styleIcon="outlined"
                      content="Encerramento"
                      secondaryContent={moment(action.endDate).format(
                        'DD/MM/YYYY'
                      )}
                    />
                  </List>

                  <div className="mt-4">
                    <div className="d-grid">
                      <Button
                        disabled={
                          !playerPerformance?.isPlayerAllowedToAnswerQuiz
                        }
                        onClick={() => navigate(`${routes.QUIZ}/${action.id}/`)}
                        text={
                          playerPerformance?.nOfAttempts === 0
                            ? 'Responder agora'
                            : !playerPerformance?.isPlayerAllowedToAnswerQuiz
                              ? 'Respondido'
                              : 'Responder de novo!'
                        }
                        color="primary"
                        icon={
                          !playerPerformance?.isPlayerAllowedToAnswerQuiz
                            ? 'check'
                            : 'description'
                        }
                      />
                    </div>
                  </div>

                  {action.quizDetails?.quizType !== 'performance' &&
                    action.quizChoice === 'false' &&
                    playerPerformance?.nOfAttempts > 0 && (
                      <div
                        className="alert alert-warning mt-3 tiny-text"
                        role="alert"
                      >
                        Você poderá reponder este Quiz novamente, mas não serão
                        atribuídos mais{' '}
                        {client?.coinName
                          ? client.coinName.replace(
                              /\((\w+)\)/,
                              (_, conteudo) => conteudo
                            )
                          : 'pontos'}
                        .
                      </div>
                    )}
                </Card>
              </div>
            </div>
          )}

          {action &&
            action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.shareButtonsVisible &&
            action.conversionType !== 'autoindicate' &&
            client &&
            client.clientUrl === 'md' && (
              <div className="col-sm-12 col-md-12 col-xl-4">
                <div className="my-3 my-xl-0">
                  <Card>
                    <span className="fw-semibold">Compartilhar</span>
                    <hr />
                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xl-12">
                        <span>Compartilhe rapidamente via</span>
                        <div className="my-3">
                          <ShareButton action={action} />
                        </div>
                        <span>Ou copie o link</span>
                        <div className="my-3">
                          <Clipboard
                            actionId={actionId}
                            shareUrl={shareUrl ? shareUrl : ''}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mt-3"></div>

                    {/* verificação qrcode validation code */}
                    {action &&
                      action.qrCodeShareURL &&
                      action.qrCodeShareURL === true &&
                      action.actionType !== 'omnichanel' && (
                        <>
                          {shareUrl && (
                            <QRCode
                              style={{ display: 'none' }}
                              id="canvas-qrcode-share-url"
                              value={shareUrl}
                              size={600}
                              className="text-center qrcode"
                            />
                          )}
                          <QrcodeWithPdf
                            valueQrcode={shareUrl ? shareUrl : ''}
                          />
                          <div className="my-3">
                            <span>
                              Se quiser indicar sem compartilhar o link, gere o
                              QRCode direto na sua tela. Basta seu indicado
                              apontar a câmera do celular dele para o código e
                              pronto.
                            </span>
                          </div>
                        </>
                      )}

                    {action &&
                      action.countDownVisible &&
                      (action.countDownVisible === true ||
                        action.countDownVisible === 'true') && (
                        <CountdownAction
                          countdownString={
                            countdownString ? countdownString : ''
                          }
                        />
                      )}
                  </Card>
                </div>

                {action && action.showPoster && (
                  <div className="mt-3 mb-3">
                    <div className={styles.card}>
                      <div className={styles.box}>
                        <p className="fw-semibold fs-4 d-flex align-items-center">
                          <i className="material-icons-outlined me-2">
                            new_releases
                          </i>
                          Novidade!
                        </p>
                        <p className="tiny-text">
                          Agora você pode baixar e imprimir cartazes com as
                          publicações, fixar a peça promocional em qualquer
                          lugar e divulgar onde quiser!
                        </p>
                        <p className="tiny-text">
                          Aproveite a novidade para aumentar sua captação de
                          clientes, gerar novas oportunidades de negócios e
                          ganhar cada vez mais!!! ;)
                        </p>
                        <div className="mt-4">
                          <Button
                            disabled={dataSlide.length <= 0}
                            text="Baixar"
                            color="primary"
                            onClick={toggleModalIsOpen}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

          {action &&
            client &&
            action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.conversionType !== 'autoindicate' &&
            !isParamAutoIndcate &&
            client.clientUrl !== 'md' && (
              <div className="col-sm-12 col-md-12 col-xl-4">
                <div className="my-3 my-xl-0">
                  <Card>
                    <span className="fw-semibold">Compartilhar</span>
                    <hr />
                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xl-12">
                        <span>Compartilhe rapidamente via</span>
                        <div className="my-3">
                          <ShareButton action={action} />
                        </div>
                        <span>Ou copie o link</span>
                        <div className="my-3">
                          <Clipboard
                            actionId={actionId}
                            shareUrl={shareUrl ? shareUrl : ''}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mt-3"></div>

                    {/* verificação qrcode validation code */}
                    {action &&
                      action.qrCodeShareURL &&
                      action.qrCodeShareURL === true &&
                      action.actionType !== 'omnichanel' && (
                        <>
                          {shareUrl && (
                            <QRCode
                              style={{ display: 'none' }}
                              id="canvas-qrcode-share-url"
                              value={shareUrl}
                              size={600}
                              className="text-center qrcode"
                            />
                          )}
                          <QrcodeWithPdf
                            valueQrcode={shareUrl ? shareUrl : ''}
                          />
                          <div className="my-3">
                            <span>
                              Se quiser indicar sem compartilhar o link, gere o
                              QRCode direto na sua tela. Basta seu indicado
                              apontar a câmera do celular dele para o código e
                              pronto.
                            </span>
                          </div>
                        </>
                      )}

                    {action &&
                      action.countDownVisible &&
                      (action.countDownVisible === true ||
                        action.countDownVisible === 'true') && (
                        <CountdownAction
                          countdownString={
                            countdownString ? countdownString : ''
                          }
                        />
                      )}
                  </Card>
                </div>

                {action && action.showPoster && (
                  <div className="mt-3 mb-3">
                    <div className={styles.card}>
                      <div className={styles.box}>
                        <p className="fw-semibold fs-4 d-flex align-items-center">
                          <i className="material-icons-outlined me-2">
                            new_releases
                          </i>
                          Novidade!
                        </p>
                        <p className="tiny-text">
                          Agora você pode baixar e imprimir cartazes com as
                          publicações, fixar a peça promocional em qualquer
                          lugar e divulgar onde quiser!
                        </p>
                        <p className="tiny-text">
                          Aproveite a novidade para aumentar sua captação de
                          clientes, gerar novas oportunidades de negócios e
                          ganhar cada vez mais!!! ;)
                        </p>
                        <div className="mt-4">
                          <Button
                            disabled={dataSlide.length <= 0}
                            text="Baixar"
                            color="primary"
                            onClick={toggleModalIsOpen}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
      {/* Modal PosterPrint */}

      <ModalPosterPrint
        modalIsOpen={modalIsOpen}
        closeModal={toggleModalIsOpen}
        clientPrimaryColor={client && client.primaryColor}
        playerName={player && player.name}
        action={action}
        shareUrl={action && action.shareUrl}
        actionImagesBase64={actionImagesBase64}
        cartazCover={cartazCover}
      />

      <ModalContact
        modalIsOpen={contactModalIsOpen}
        toggleModal={() => {
          openContactModal();
          navigate(routes.HOME);
        }}
        clientUrl={client?.clientUrl}
        player={player}
        isAutoIndicate={true}
        customText={
          player && player.regional === 'sim'
            ? ' Muito bom! O lead foi registrado com sucesso!'
            : client && client.clientUrl === 'bomnegocio'
              ? 'Obrigado! Vamos checar os dados que você nos enviou e te manteremos informados! :)'
              : 'Obrigado! Em breve entraremos em contato com a sua indicação.'
        }
      />
    </>
  );
}
